/**
 * File: teacherViewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class TeacherViewController {
    // @ngInject
    constructor($state, $rootScope, $scope, $stateParams, localStorageService, authService, profileCons) {

        let selectedUserId = $stateParams.person_id

        $scope.working_hours = {}

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Get teacher details
         **/
        let getEndorsedAcademics = () => {
            authService.callAPI(profileCons.API_TEACHER_ENDORSE_DETAILS + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, (response) => {
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.academics = response.result.data.details
                    $scope.working_hours = response.result.data.working_hours ? response.result.data.working_hours.working_hours : undefined

                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        this.$onInit = function() {
            $scope.working_hours = {}
            getEndorsedAcademics();
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: To update/save working hours
         **/
        $scope.updateUser = () => {

            if (!$scope.working_hours) {
                toastr.error("Please enter weekly details")
                return false
            }

            if (!$scope.working_hours.weekly || isNaN($scope.working_hours.weekly)) {
                toastr.error("Please enter weekly max hours")
                return false
            }
            if (!$scope.working_hours.daily || isNaN($scope.working_hours.daily)) {
                toastr.error("Please enter daily max hours")
                return false
            }
            /* if (isNaN($scope.working_hours.weekly)) {
                toastr.error("Please enter valid weekly max hours")
                return false
            }
            if (isNaN($scope.working_hours.daily)) {
                toastr.error("Please enter valid daily max hours")
                return false
            } */

            if (parseInt($scope.working_hours.daily) > parseInt($scope.working_hours.weekly)) {
                toastr.error("Daily max hours should not be greater!")
                return false
            }


            let obj = {
                'school_id': localStorageService.get('school_id'),
                'user_id': selectedUserId,
                'working_hours': $scope.working_hours
            }


            authService.callAPI(profileCons.API_UPDATE_WORKING_HRS, "POST", obj, (response) => {
                console.log(response)
                if (response.result && response.result.data) {
                    toastr.success("Working hours saved!")
                    getEndorsedAcademics();
                }
            })
        }

    }
}


export default TeacherViewController;


// WEBPACK FOOTER //
// ./src/app/profileSetting/controllers/teacherViewController.js